import React, { useEffect, useState } from 'react';
import { TestDetails } from './TestDetails';
import { MetricsOverview } from './MetricsOverview';
import { StatisticalMatrix } from './StatisticalMatrix';
import { AssetAnalysis } from './AssetAnalysis';
import { KeyInsights } from './KeyInsights';
import { Toast } from './Toast';
import { mockImageData } from '../utils/mockData';
import { TrophyIcon, AlertTriangleIcon } from 'lucide-react';
interface DashboardProps {
  timeRange: string;
}
export const Dashboard: React.FC<DashboardProps> = () => {
  const [showToast, setShowToast] = useState(false);
  const data = mockImageData;
  useEffect(() => {
    // Reset localStorage for testing
    localStorage.removeItem('hasShownNotification');
    // Small delay to ensure component is mounted
    const timer = setTimeout(() => {
      if (window.innerWidth <= 1024) {
        setShowToast(true);
      }
    }, 1000);
    return () => clearTimeout(timer);
  }, []);
  return <div className="space-y-6 relative" data-id="element-151">
      <Toast show={showToast} onClose={() => setShowToast(false)} data-id="element-152" />
      <div id="overview" data-id="element-153">
        <div className="mb-10" data-id="element-154">
          <div className="flex items-center space-x-3 mb-3" data-id="element-155">
            <div className="text-[#C00000] text-xs font-bold tracking-[0.1em] uppercase" data-id="element-156">
              MEASUREMENT REPORT
            </div>
            <div className="flex items-center bg-[#101010] text-white px-2 py-1 rounded-sm text-[10px] font-bold tracking-wider uppercase" data-id="element-157">
              <AlertTriangleIcon className="h-3 w-3 mr-1 text-[#C00000]" data-id="element-158" />
              ILLUSTRATIVE EXAMPLE · FICTIONAL DATA
            </div>
          </div>
          <h1 className="text-5xl md:text-7xl font-bold tracking-[-1.44px] text-[#101010] flex items-center flex-wrap gap-4" data-id="element-159">
            Lenovo EMEA
            <span className="inline-flex items-center px-3 py-1 rounded-sm text-sm font-medium bg-[#C00000] text-white ml-2 align-middle tracking-normal" data-id="element-160">
              Completed
            </span>
          </h1>
        </div>
        <h2 className="text-lg font-medium text-[#101010] mb-4" data-id="element-161">
          Test Details
        </h2>
        <TestDetails data={data} data-id="element-162" />
      </div>
      <div id="performance" data-id="element-163">
        <h2 className="text-lg font-medium text-[#101010] mb-4" data-id="element-164">
          Performance Overview
        </h2>
        <MetricsOverview data={data} data-id="element-165" />
      </div>
      <div id="analysis" data-id="element-166">
        <div className="flex items-center mb-4" data-id="element-167">
          <h2 className="text-lg font-medium text-[#101010] mr-3" data-id="element-168">
            Detailed Asset Analysis
          </h2>
        </div>
        <AssetAnalysis data={data} data-id="element-169" />
      </div>
      <div id="statistics" data-id="element-170">
        <h2 className="text-lg font-medium text-[#101010] mb-4" data-id="element-171">
          Statistical Analysis
        </h2>
        <StatisticalMatrix data={data} data-id="element-172" />
      </div>
      <div id="recommendations" data-id="element-173">
        <KeyInsights data-id="element-174" />
      </div>
    </div>;
};